export const Colors = {
    primaryColor :  '#8bc34a',
    darkPrimaryColor:'#6b9738',
    ligthPrimaryColor: '#a3ce73'
}